import withSentryWrapper from 'src/components/common/withSentryWrapper'

const Pagenotfound = () => {
    return (
        <div className="flex h-full w-full flex-col items-center justify-center">
            <p className="m-0 text-2xl">
                Whoops! The page you're looking for does not exist.
            </p>
        </div>
    )
}

export default withSentryWrapper(Pagenotfound)
